/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type User = Record<string, any>;

type LoginState = {
  isBootstrapping: boolean;
  isLoggedIn: boolean;
  user: User | null;
   appMaintenance:boolean,
  maintenanceMessage:string,
  portalName:string,
  portalSecondaryHeader:string
};

const initialState: LoginState = {
  isBootstrapping: true,
  isLoggedIn: false,
  user: null,
  appMaintenance:false,
  maintenanceMessage:"",
  portalName:"main.portalName.customer",
  portalSecondaryHeader:""
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setBootstrapping: (s, a: PayloadAction<boolean>) => { s.isBootstrapping = a.payload; },
    toggleLogin: (s, a: PayloadAction<boolean>) => { s.isLoggedIn = a.payload; },
    setUser: (s, a: PayloadAction<User | null>) => { s.user = a.payload; },
    resetAuth: (s) => { s.isBootstrapping = false; s.isLoggedIn = false; s.user = null; },
    setMaintenanceMessage:(state,action)=>{
      state.maintenanceMessage = action.payload
    },
    setMaintenanceEnabled:(state,action)=>{
      state.appMaintenance = action.payload
    },
    setPortalName:(state,action)=>{
      state.portalName = action.payload
    },
    setPortalSecondaryHeader:(state,action)=>{
      state.portalSecondaryHeader = action.payload
    },
  },
});

export const { setBootstrapping, toggleLogin, setUser, resetAuth,setMaintenanceEnabled,setMaintenanceMessage,setPortalName,setPortalSecondaryHeader } = loginSlice.actions;
export const isLoggedInSelector = (s: { login: LoginState }) => s.login;
export default loginSlice.reducer;
